// extracted by mini-css-extract-plugin
export default {"dateGrid":"nuevoPendiente_dateGrid__qCgP9","surfaceGrid":"nuevoPendiente_surfaceGrid__x0eiK"};